
<ScrollContainer v-if="!loading">
  <EditForm
    :user-data="user"
    :roles="roleItems"
    :entities="entities"
    :on-cancel="handleOnClose"
    :on-success="handleOnSuccess"
  />
</ScrollContainer>
